import React from 'react';
import BaseCalculatedOrders, { OrderSide } from '../orders/BaseCalculatedOrders';
import {
  getCalculatedBuyOrders,
  getCalculatedSellOrders,
  getBrokersByScheme,
  bulkAssignBroker,
  assignBrokerToOrder,
  submitCalculatedOrders,
  submitCalculatedSellOrders,
  bulkAssignSellBroker,
  assignBrokerToSellOrder,
} from './api';
import { formatNumber } from '@/utils/formatters';
import styles from '@/components/orders/OrderManagement.module.css';
import { AggregatedOrder } from '@/components/orders/types';

interface CalculatedOrdersProps {
  onOrdersSubmitted: () => void;
}

const CalculatedOrders: React.FC<CalculatedOrdersProps> = ({ onOrdersSubmitted }) => {
  return (
    <BaseCalculatedOrders
      supportsNri={true}
      onOrdersSubmitted={onOrdersSubmitted}
      fetchBuyOrders={() =>
        getCalculatedBuyOrders({ page_size: 100, aggregate_non_nri: true }).then(res => ({
          aggregatedOrders: res.aggregated_non_nri || [],
          nriOrders: res.nri_orders || [],
          summary: { total_count: res.count, total_quantity: res.total_quantity, total_amount: res.total_amount, currency: res.currency },
        }))
      }
      fetchSellOrders={() =>
        getCalculatedSellOrders({ page_size: 100, aggregate_non_nri: true }).then(res => ({
          aggregatedOrders: res.aggregated_non_nri || [],
          nriOrders: res.nri_orders || [],
          summary: { total_count: res.count, total_quantity: res.total_quantity, total_amount: res.total_amount, currency: res.currency },
        }))
      }
      bulkAssignBroker={(side: OrderSide, orderIds: number[], brokerId: number | null) =>
        side === 'buy' ? bulkAssignBroker(orderIds, brokerId) : bulkAssignSellBroker(orderIds, brokerId)
      }
      assignNriBroker={(side: OrderSide, id: number, brokerId: number | null) =>
        side === 'buy' ? assignBrokerToOrder(id, brokerId) : assignBrokerToSellOrder(id, brokerId)
      }
      fetchBrokersByScheme={(schemeId, clientId) => getBrokersByScheme(schemeId, clientId)}
      submitOrders={(side: OrderSide, orderIds: number[], emailRecipients?: string[]) => {
        const submitFn = side === 'buy' ? submitCalculatedOrders : submitCalculatedSellOrders;
        return submitFn({
          order_ids: orderIds,
          ...(emailRecipients && emailRecipients.length > 0 ? { email_recipients: emailRecipients } : {})
        });
      }}
      renderExtraAggregatedHeaders={() => (
        <>
          <th className={styles.num}>Orders</th>
          <th className={styles.num}>Total Qty</th>
        </>
      )}
      renderExtraAggregatedCells={(order: AggregatedOrder) => (
        <>
          <td className={styles.num}>{order.order_count}</td>
          <td className={`${styles['text-mono']} ${styles.num}`}>{formatNumber(order.total_quantity, 0)}</td>
        </>
      )}
    />
  );
};

export default CalculatedOrders;